import { Card, Image, makeStyles, Text } from "@fluentui/react-components";
import IPageFeature, { IFeature } from "../../../models/page/pageComponents/IPageFeature";
import { dolphinTokens } from "../../../utils/Theme";

const useStyles = makeStyles({
    cardsSection: {
        display: "flex",
        flexWrap: "wrap",
        gap: "2rem", // Wider gap between cards
        width: "100%",
        justifyContent: "center", // Center align cards
        
        '@media (max-width: 768px)': {
            gap: "1.5rem",
        },
    },
    cardWrapper: {
        display: "flex",
        flexDirection: "column",
        flexBasis: "calc(45% - 2rem)", // Smaller cards, slightly less than half width
        maxWidth: "calc(45% - 2rem)", // Ensure cards are smaller
        
        // Stack cards vertically on smaller screens
        '@media (max-width: 768px)': {
            flexBasis: "100%",
            maxWidth: "100%",
        },

        // Alternate background color for odd items on smaller screens
        "@media only screen and (max-width: 768px)": {
            "&:nth-child(odd) > div": {
                backgroundColor: dolphinTokens.colorDarkBlue,
                color: "white",
            }
        },

        // Alternate background color for second and third items in every group of four
        "@media only screen and (min-width: 768px)": {
            "&:nth-child(4n+2) > div, &:nth-child(4n+3) > div": {
                backgroundColor: dolphinTokens.colorDarkBlue,
                color: "white",
            }
        }
    },
    card: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        height: "100%",
        padding: "0.75rem",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Subtle shadow for better visibility
        borderRadius: "8px"
    },
    imageWrapper: {
        width: "100%",
        height: "250px", // Uniform height for all images
        marginBottom: "0.75rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden", // Crop longer images,
    },
    image: {
        maxWidth: "100%", // Ensure the image does not stretch beyond its container
        maxHeight: "250px", // Ensure the image does not stretch beyond its container
        height: "auto", // Maintain aspect ratio
        objectFit: "cover", // Make the image fit nicely inside the container
        alignSelf: "flex-start", // Start from the top
    },
    textWrapper: {
        width: "100%",
        marginBottom: "0.75rem",
    }
});

const CardItem = (props: { feature: IFeature }) => {
    const { feature } = props;
    const styles = useStyles();

    return (
        <div className={`${styles.cardWrapper}`}>
            <Card className={styles.card}>
                <div className={styles.imageWrapper}>
                    <Image
                        src={feature.image.url}
                        alt={feature.image.altText}
                        className={styles.image}
                        />
                </div>
                <div className={styles.textWrapper}>
                    <Text as="h2" block size={600} align="center">
                        {feature.title}
                    </Text>
                    <Text as="h4" block size={400} align="center">
                        {feature.description}
                    </Text>
                </div>
            </Card>
        </div>
    );
};

export default function FeaturesLayout2(props: IPageFeature) {
    const styles = useStyles();

    return (
        <div className={styles.cardsSection}>
            {
                props.features.map((feature, index) => <CardItem key={index} feature={feature} />)
            }
        </div>
    );
}